import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js'
import { BASIC_THEME, updateTheme } from '@debbie/iris/dist/theme.js'
import React, { useEffect, useState } from 'react'

import { IS_PROD } from '../config.js'

const useCollector = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [collector, setCollector] = useState<any>(null)

  useEffect(() => {
    fetchCollector()
  }, [])

  const fetchCollector = async () => {
    try {
      if (!isLoading && !collector) {
        setIsLoading(true)

        const domainBase = window.location.hostname
        const newCollector = await collectorsAPI.getBySiteBase(
          !IS_PROD ? 'demo.com' : domainBase,
        )

        updateTheme(newCollector.theme || BASIC_THEME)

        if (newCollector) {
          setIsLoading(false)
          setCollector(newCollector)

          document.title = newCollector.name
        } else {
          setIsLoading(false)
        }
      }
    } catch (error) {
      setIsLoading(false)
      setCollector(null)
    }
  }

  return { isLoading, collector }
}

export default useCollector
